import type { TFunction } from 'i18next'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { productSearchOverrides } from './styled-components'

interface ProductSearchProps {
  t: TFunction
  value: string
  onChange: (value: string | null) => void
}

const ProductSearch = ({ t, value, onChange }: ProductSearchProps) => (
  <SDFormControl plainLabel overrides={productSearchOverrides}>
    {/* @ts-expect-error -- SDInput is a JS component without prop types for TypeScript */}
    <SDInput
      label={t('additionalSales:common.filter_sales_label')}
      type='search'
      autoComplete='off'
      currentValue={value}
      outerOnchange={onChange}
    />
  </SDFormControl>
)

export default ProductSearch
